var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "PageContent",
    [
      _c("InputTitleSlug", {
        attrs: {
          id: "header-main-form",
          "id-title": "title",
          "is-loading": _vm.loading || _vm.disabled,
          title: _vm.data.title,
          "title-error": _vm.validationErrors.title,
          slug: _vm.data.slug,
          "slug-error": _vm.validationErrors.slug,
          validationErrors: _vm.$options.validationRules,
          isSlugEnabled: !_vm.isNew,
        },
        on: {
          "change:title": function ($event) {
            return _vm.$emit("change:title", $event)
          },
          "change:slug": function ($event) {
            return _vm.$emit("change:slug", $event)
          },
          "input:slug": function ($event) {
            return _vm.$emit("input:slug", $event)
          },
        },
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Тип бронирования*")]),
              _c("v-select", {
                attrs: {
                  id: "bookingType",
                  outlined: "",
                  "no-data-text": "Список пуст",
                  "item-value": "value",
                  "item-text": "title",
                  loading: _vm.loading,
                  disabled: _vm.disabled,
                  "error-messages": _vm.validationErrors.bookingType,
                  items: _vm.$options.bookingTypes,
                  value: _vm.data.bookingType,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:bookingType", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "span",
                [_vm._v("Подзаголовок ("), _c("TranslationIcon"), _vm._v(")")],
                1
              ),
              _c("v-text-field", {
                attrs: {
                  outlined: "",
                  loading: _vm.loading,
                  disabled: _vm.disabled,
                  value: _vm.data.subtitle,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:subtitle", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("MediaFilePicker", {
                attrs: {
                  id: "thumbnailId",
                  label: "Миниатюра*",
                  multiple: false,
                  "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                  value: _vm.data.thumbnailId,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:thumbnailId", $event)
                  },
                },
              }),
              _c("ErrorMessage", {
                attrs: { message: _vm.validationErrors.thumbnailId },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("MediaFilePicker", {
                attrs: {
                  label: "Изображения",
                  "file-type": _vm.$options.mediaTypesByKeys.IMAGE,
                  value: _vm.data.images,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:images", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Цена*")]),
              _c("v-text-field", {
                attrs: {
                  id: "price",
                  outlined: "",
                  loading: _vm.loading,
                  disabled: _vm.disabled,
                  "error-messages": _vm.validationErrors.price,
                  value: _vm.data.price,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:price", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("span", [_vm._v("Место проведения*")]),
              _c("LocationAutocomplete", {
                attrs: {
                  id: "address",
                  address: _vm.data.address,
                  loading: _vm.loading || _vm.disabled,
                  "error-messages": _vm.validationErrors.address[0],
                },
                on: {
                  "set-location": _vm.setLocation,
                  "update-location-part": _vm.updateLocation,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("v-col", { staticClass: "pb-0", attrs: { cols: "6" } }, [
            _c(
              "span",
              { attrs: { id: "description" } },
              [_vm._v("Описание* ("), _c("TranslationIcon"), _vm._v(")")],
              1
            ),
          ]),
          _c("QuillEditorVue", {
            attrs: {
              cols: 12,
              title: "",
              isShowErrorMessage: true,
              errorText: _vm.validationErrors.description,
              content: _vm.data.description,
              loading: _vm.loading,
              "light-mode": "",
              disabled: _vm.disabled,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("change:description", $event)
              },
              onChangeContent: function ($event) {
                return _vm.$emit("change:descriptionForMobile", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c("span", [_vm._v("Возрастное ограничение*")]),
              _c("v-select", {
                attrs: {
                  id: "ageRestriction",
                  outlined: "",
                  items: _vm.$options.ageList,
                  disabled: _vm.loading,
                  loading: _vm.loading,
                  "error-messages": _vm.validationErrors.ageRestriction,
                  value: _vm.data.ageRestriction,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change:ageRestriction", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(
        _vm.category.attributeKeys,
        function (attributeField, attributeFieldIndex) {
          return _c(
            "v-row",
            { key: attributeFieldIndex },
            [
              _c(
                "v-col",
                { attrs: { cols: "6" } },
                [
                  _c(`attribute-field-${attributeField.type}`, {
                    tag: "component",
                    attrs: {
                      "attribute-data": attributeField,
                      "is-loading": _vm.loading || _vm.disabled,
                      value: _vm.getAttributeValue(attributeField),
                      "error-message":
                        _vm.getAttributeErrorMessage(attributeField),
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateAttributeValue($event, attributeField)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("SeoSettings", {
                attrs: {
                  data: _vm.seoData,
                  loading: _vm.loading || _vm.disabled,
                },
                on: {
                  "on-input-seo": function ($event) {
                    return _vm.$emit("on-input-seo", $event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }